const initGeoRedirect = () => {
  const STORAGE_KEY = 'geo_redirect_dismissed';
  if (sessionStorage.getItem(STORAGE_KEY)) return;

  const { hostname } = window.location;
  const isUSSite = hostname === 'venroy.com';
  const isAUSite = hostname === 'venroy.com.au';
  if (!isUSSite && !isAUSite) return;

  const POLL_INTERVAL = 2000;
  const POLL_TIMEOUT = 10000;

  const banner = document.querySelector('[data-geo-redirect]');
  const textEl = document.querySelector('[data-geo-redirect-text]');
  const acceptBtn = document.querySelector('[data-geo-redirect-accept]');
  const dismissBtn = document.querySelector('[data-geo-redirect-dismiss]');
  if (!banner || !textEl || !acceptBtn || !dismissBtn) return;

  const buildRedirectUrl = () => {
    if (isUSSite) return window.location.href.replace(hostname, 'venroy.com.au');
    return window.location.href.replace('venroy.com.au', 'venroy.com');
  };

  const MESSAGES = {
    TO_AU: 'It looks like you\u2019re outside the US. Would you like to visit our Australian store?',
    TO_US: 'It looks like you\u2019re in the United States. Would you like to visit our US store?',
  };

  const showBanner = (message, url) => {
    textEl.textContent = message;
    acceptBtn.href = url;
    banner.hidden = false;
  };

  dismissBtn.addEventListener('click', () => {
    sessionStorage.setItem(STORAGE_KEY, '1');
    banner.hidden = true;
  });

  const interval = setInterval(() => {
    const region = window.Shopify?.customerPrivacy?.getRegion?.();
    if (!region) return;

    clearInterval(interval);
    const countryCode = region.substring(0, 2).toUpperCase();

    if (isUSSite && countryCode !== 'US') {
      showBanner(MESSAGES.TO_AU, buildRedirectUrl());
    } else if (isAUSite && countryCode === 'US') {
      showBanner(MESSAGES.TO_US, buildRedirectUrl());
    }
  }, POLL_INTERVAL);

  setTimeout(() => clearInterval(interval), POLL_TIMEOUT);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initGeoRedirect);
} else {
  initGeoRedirect();
}
